/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 警告・やることモード
 */
export type DeadlineMode = 'ALL' | 'DAILY' | 'ASSIGN' | 'WORK' | 'REPORT' | 'MONTHLY' | 'SHIFT' | 'ATTENDANCE' | 'EXPENSE' | 'PAYSLIP' | 'INVOICE_INPUT' | 'INVOICE';

export const DeadlineMode = {
    All: 'ALL' as DeadlineMode,
    Daily: 'DAILY' as DeadlineMode,
    Assign: 'ASSIGN' as DeadlineMode,
    Work: 'WORK' as DeadlineMode,
    Report: 'REPORT' as DeadlineMode,
    Monthly: 'MONTHLY' as DeadlineMode,
    Shift: 'SHIFT' as DeadlineMode,
    Attendance: 'ATTENDANCE' as DeadlineMode,
    Expense: 'EXPENSE' as DeadlineMode,
    Payslip: 'PAYSLIP' as DeadlineMode,
    InvoiceInput: 'INVOICE_INPUT' as DeadlineMode,
    Invoice: 'INVOICE' as DeadlineMode
};

